import type { ReportBlock } from '../types';

/** Base inteiramente fictícia: 320 notificações disparadas em 610 tentativas. Cada taxa tem o
 * próprio denominador e nenhuma se soma entre canais (T5); leitura não prova resultado jurídico. */
export const blocosDaDemonstracaoDaNotificacao: ReportBlock[] = [
  {
    id: 'overview',
    title: 'O período em perspectiva',
    summary:
      'Uma base de exemplo para explorar como a Lex organiza o seu fechamento. Todos os valores desta demonstração são fictícios.',
    metrics: [
      {
        label: 'Notificações disparadas',
        value: '320',
        detail: 'Primeiro envio no período, em qualquer canal',
      },
      {
        label: 'Tentativas de envio',
        value: '610',
        detail: 'Cada canal e cada contato contam à parte',
      },
      {
        label: 'Com entrega confirmada',
        value: '90%',
        detail: '288 de 320 notificações, em ao menos um canal',
      },
      {
        label: 'Com manifestação',
        value: '64',
        detail: 'Discordância, pedido de negociação ou manifestação do notificado',
      },
    ],
    notes: [
      'Base ilustrativa: notificações distintas pela data de disparo. Notificação, tentativa e destinatário são unidades diferentes e não se misturam.',
    ],
  },
  {
    id: 'channels',
    title: 'Desempenho por canal',
    summary:
      'Cada canal tem a própria taxa, sobre as tentativas dele: as taxas não se somam entre canais. SMS não informa leitura, e o traço na tabela não é zero.',
    metrics: [
      {
        label: 'Entrega por e-mail',
        value: '90%',
        detail: '270 de 300 tentativas do canal',
      },
      {
        label: 'Entrega por WhatsApp',
        value: '96%',
        detail: '240 de 250 tentativas do canal',
      },
      { label: 'Entrega por SMS', value: '90%', detail: '18 de 20 tentativas do canal' },
      { label: 'Entrega por RCS', value: '75%', detail: '30 de 40 tentativas do canal' },
    ],
    columns: ['Canal', 'Tentativas', 'Entregues', 'Lidas ou abertas'],
    rows: [
      ['E-mail', '300', '270', '120'],
      ['WhatsApp', '250', '240', '150'],
      ['SMS', '20', '18', '—'],
      ['RCS', '40', '30', '12'],
    ],
    notes: [
      'A abertura de e-mail tem garantia técnica menor que a confirmação de leitura do WhatsApp e do RCS: compare as leituras entre canais com cautela.',
    ],
  },
  {
    id: 'delivery',
    title: 'Do envio à leitura',
    summary:
      'Das 320 notificações disparadas, 288 tiveram entrega confirmada pelo provedor e 190 tiveram leitura ou abertura registrada. Leitura registrada não prova resultado jurídico nem pagamento.',
    bars: [
      { label: 'Disparadas', value: 320, total: 320 },
      { label: 'Com entrega confirmada', value: 288, total: 320 },
      { label: 'Com leitura ou abertura', value: 190, total: 320 },
    ],
    notes: [
      'Consolidado deduplicado: cada notificação conta uma vez, mesmo com entrega em mais de um canal.',
    ],
  },
  {
    id: 'manifestations',
    title: 'O que os notificados disseram',
    summary:
      '64 das 320 notificações tiveram manifestação do notificado, 20% da base. Uma notificação pode aparecer em mais de um tipo, e o envio de comprovante fica à parte.',
    metrics: [
      {
        label: 'Discordância',
        value: '20',
        detail: 'Notificações com ao menos uma discordância do notificado',
      },
      {
        label: 'Pedido de negociação',
        value: '30',
        detail: 'Notificações em que o notificado pediu para negociar',
      },
      {
        label: 'Resposta ou manifestação',
        value: '25',
        detail: 'Respostas e manifestações livres do notificado',
      },
      {
        label: 'Comprovante enviado',
        value: '6',
        detail: 'Envio de comprovante não confirma pagamento',
      },
    ],
  },
  {
    id: 'batches',
    title: 'Lotes lado a lado',
    summary:
      'As 320 notificações do exemplo por lote de origem, com o mesmo critério de entrega e de manifestação em todas as linhas.',
    columns: ['Lote', 'Notificações', 'Com entrega', 'Com manifestação'],
    rows: [
      ['Lote de exemplo A', '200', '180', '40'],
      ['Lote de exemplo B', '100', '90', '20'],
      ['Notificações avulsas', '20', '18', '4'],
    ],
  },
  {
    id: 'evidence',
    title: 'Evidências registradas',
    summary:
      'Das 320 notificações do exemplo, 300 têm certificado emitido e 140 têm acesso registrado ao portal. O certificado reúne os eventos registrados; este relatório não avalia a validade jurídica deles.',
    metrics: [
      {
        label: 'Com certificado emitido',
        value: '300',
        detail: 'O PDF do certificado foi gerado para a notificação',
      },
      {
        label: 'Com acesso ao portal',
        value: '140',
        detail: 'Primeiro acesso pelo link registrado; não identifica quem acessou',
      },
    ],
  },
  {
    id: 'actions',
    title: 'Do resultado à próxima decisão',
    summary:
      'Sugestões ilustrativas com base nos indicadores deste exemplo. A decisão, e qualquer novo envio, permanecem com a sua equipe.',
    notes: [
      '01 · Das 320 notificações, 288 tiveram entrega confirmada: revise os contatos das demais antes de decidir por um novo envio.',
      '02 · Avalie o retorno às 30 notificações com pedido de negociação.',
      '03 · Encaminhe à análise da equipe as 20 notificações com discordância.',
    ],
  },
];
